// extracted by mini-css-extract-plugin
export default {"imageWrapper":"Image_imageWrapper__GTqU9","image":"Image_image__UAEvJ","removeImage":"Image_removeImage__50GDb"};